const InboxLink = {
  label: "Inbox"
};

export default InboxLink;
